<template>
  <b-navbar toggleable="md" class="white-bg navbar-main" data-trackname="navbar">

    <!-- Logo -->
    <b-navbar-brand :to="{name: 'Map' }" data-trackname="topNavbarBrand" class="navbar-brand-k">
      <img src="@/assets/img/logo_nedgia-icon.png" alt="Nedgia">
    </b-navbar-brand>
    <!-- Logo END -->

    <!-- toggle button for small devices -->
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <!-- toggle button for small devices END -->

    <!-- Navbar Menu -->
    <b-collapse is-nav id="nav_collapse" class="justify-content-between">
      <b-navbar-nav>
        <button v-if="isMap" class="btn btn-empty" @click="toggleLayers"><i class="fa fa-reorder"
                                                                            style="padding-left: 0em"></i></button>
      </b-navbar-nav>

      <b-navbar-nav style="width:80%;min-width:75rem">
        <h3 style='margin-top:4px;color:red;width:380px;' v-if="isPre">Entorno de test</h3>
        <searchBar v-if="isMap"></searchBar>
        <a class="btn btn-empty" :href="'mailto:'+supportEmail" target="_top">
          Soporte y Ayuda
          <i class="fa fa-question-circle"></i>
        </a>

        <b-dropdown class="nav-user" variant="outline-primary">

          <template slot="button-content">
            <span @mouseover="ishover = true" @mouseout="ishover = false">
              <b-badge v-if="notCount>0" variant="dark">{{ notCount }}</b-badge>
              <span v-else class="fa-stack">
                <i class="fa fa-circle fa-stack-2x"></i>
                <i class="fa fa-user fa-stack-1x fa-inverse"></i>
              </span>
              <span>{{ user.username }}</span>
            </span>
          </template>
          <b-dropdown-item @click="showNotifications=true" data-trackname="navbarBtnLogout">
            <b-badge v-if="notCount>0" variant="dark">{{ notCount }}</b-badge>
            Notificaciones
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item @click="logout" data-trackname="navbarBtnLogout">
            Salir
          </b-dropdown-item>

        </b-dropdown>
      </b-navbar-nav>
    </b-collapse>
    <!-- Navbar Menu END -->

    <HelpSidePanel ref="helpPanel">

      <!-- <v-client-table
        :data="ayuda.data"
        :columns="ayuda.columns"
        :options="ayuda.options">
      </v-client-table> -->

    </HelpSidePanel>

    <div v-if="isMap" class="sidebar" ref="layersPanel">
      <div class="sidebar-container">
        <div class="row">
          <!-- <div class="row" style="position:fixed"> -->
          <div class="col-8">
            <img src="@/assets/img/logo_nedgia.png" alt="Logo" style="width: 100%;">
          </div>
          <div class="col-4">
            <button class="btn  btn-outline-primary"
                    :class="{'btn-primary':help}"
                    @click="toggleLayers">
              <i class="fa fa-close" style="margin-right: 0rem; padding-left: 0em;"></i>
            </button>
          </div>
        </div>
        <!-- <div style="padding-top:2rem;"></div> -->

        <ul class="nav nav-pills flex-column border-top mt-4">
          <div class='section-group-collapse' v-for="group in layersList" v-bind:key="group.name">
            <template v-if="(hasPermision(group, 'V') || (hasPermision(group, 'A') && group.name==='Red'))">
              <template v-if="group.name === 'Comercial'">
                <li class="nav-item">
                  <button class="btn btn-empty" @click="toggleGroupOptions(comercial)">
                    <i v-if="!comercial.show" class="fa fa-chevron-down" style=""></i>
                    <i v-else class="fa fa-chevron-up" style=""></i>
                  </button>

                  <b-form-checkbox v-model="comercial.active" :indeterminate="comercial.indeterminate"
                                   @change="toggleComercialGroup($event, comercial)" inline>
                    {{ comercial.name }}
                    <i v-if="isComercialFiltered" class="fa fa-filter"></i>
                  </b-form-checkbox>
                </li>
                <b-button-group class='group-btn-actions' size="sm"
                                v-if="comercial.show && comercial.actions && comercial.actions.length > 0">
                  <template v-for="action in comercial.actions">
                    <b-button v-if="hasPermision(comercial, action.p)"
                              @click="executeFunction(action.function, 'comercial')" v-bind:key="action.name"
                              variant="outline-primary">
                      <i :class="action.icon" aria-hidden="true"></i>
                    </b-button>
                  </template>
                </b-button-group>
                <li class='etiquetas-btn' v-if="comercial.show">
                  <!-- <b-button @click="">Labels</b-button> -->
                  <b-form-checkbox v-model="comercialLabels" @change="toggleLabel(group)" inline>
                    Etiquetas
                  </b-form-checkbox>
                  <!-- <b-form-checkbox v-model="comerciosGoogle" @input="toggleGoogle">
                    Comercios Google
                  </b-form-checkbox> -->
                </li>
                <template v-if="comercial.show">
                  <li v-for="(layer,i) in comercial.layers" :key="i" class="sub-item">
                    <switches class='nav-switch' :emit-on-mount='false' :value="comercial.layers[i].active"
                              style="margin-top: .5rem;" color="blue"
                              @input="toggleComercialLayer($event, i, comercial)"></switches>
                    <span class='nav-subitem-span'>
                      <img :src='"../../assets/img/icons/" + layer.id + ".png"'>
                      {{ capitalizeFirstLetter(layer.categoria_gn_comercial) }}
                      <span v-if="layer.count" class="smaller">({{ layer.count.toLocaleString() }})</span>
                    </span>
                  </li>
                </template>
              </template>
              <template v-else-if="group.name === 'Caldera'">
                <li class="nav-item">
                  <button class="btn btn-empty" @click="toggleGroupOptions(caldera)">
                    <i v-if="!caldera.show" class="fa fa-chevron-down" style=""></i>
                    <i v-else class="fa fa-chevron-up" style=""></i>
                  </button>

                  <b-form-checkbox v-model="caldera.active" :indeterminate="caldera.indeterminate"
                                   @change="toggleComercialGroup($event, caldera)" inline>
                    {{ caldera.name }}
                    <i v-if="isCalderaFiltered" class="fa fa-filter"></i>
                  </b-form-checkbox>
                </li>
                <b-button-group class='group-btn-actions' size="sm"
                                v-if="caldera.show && caldera.actions && caldera.actions.length > 0">
                  <template v-for="action in caldera.actions">
                    <b-button v-if="hasPermision(caldera, action.p)"
                              @click="executeFunction(action.function, 'caldera')" v-bind:key="action.name"
                              variant="outline-primary">
                      <i :class="action.icon" aria-hidden="true"></i>
                    </b-button>
                  </template>
                </b-button-group>
                <template v-if="caldera.show">
                  <li v-for="(layer, i) in caldera.layers" v-bind:key="layer.categoria_gn_caldera+'caldera'"
                      class="sub-item">
                    <switches class='nav-switch' :emit-on-mount='false' :value="caldera.layers[i].active"
                              style="margin-top: .5rem;" color="blue"
                              @input="toggleComercialLayer($event, i, caldera)"></switches>
                    <span class='nav-subitem-span'>
                      <img :src='"../../assets/img/icons/cald_" + layer.id + ".png"' height="15" width="15">
                      {{ capitalizeFirstLetter(layer.categoria_gn_caldera) }}
                      <span v-if="layer.count" class="smaller">({{ layer.count.toLocaleString() }})</span>
                    </span>
                  </li>
                </template>
              </template>
              <template v-else-if="group.name === 'Territorio'">
                <li class="nav-item">
                  <button class="btn btn-empty" @click="toggleGroupOptions(group)">
                    <i v-if="!group.show" class="fa fa-chevron-down" style=""></i>
                    <i v-else class="fa fa-chevron-up" style=""></i>
                  </button>

                  <b-form-checkbox v-model="group.active" :indeterminate="group.indeterminate"
                                   @input="toggleGroup(group)" inline>
                    {{ group.name }}
                  </b-form-checkbox>
                </li>

                <b-button-group class='group-btn-actions' size="sm"
                                v-if="group.show && group.actions && group.actions.length > 0">
                  <template v-for="action in group.actions">
                    <b-button @click="executeFunction(action.function, group)" v-bind:key="action.name"
                              v-if="hasPermision(group, action.p)" variant="outline-primary">
                      <i :class="action.icon" aria-hidden="true"></i>
                    </b-button>
                  </template>
                </b-button-group>
                <template v-if="group.show">
                  <li v-for="layer in group.layers"
                      v-bind:key="layer.name"
                      v-show="ShowTerritorio(layer)"
                      class="sub-item">
                    <switches class='nav-switch' v-model="layer.active" style="margin-top: .5rem;" color="blue"
                              @input="toggleLayer(layer, group)"></switches>
                    <span class='nav-subitem-span'>
                      <img v-if="layer.icon_name" :src='"../../assets/img/icons/" + layer.icon_name + ".png"'
                           height="15" width="15">
                      {{ capitalizeFirstLetter(layer.name) }}
                      <span v-if="layer.count" class="smaller">({{ layer.count.toLocaleString() }})</span>
                    </span>
                  </li>
                </template>
              </template>
              <template v-else> <!-- Red -->
                <li class="nav-item">
                  <button class="btn btn-empty" @click="toggleGroupOptions(group)">
                    <i v-if="!group.show" class="fa fa-chevron-down" style=""></i>
                    <i v-else class="fa fa-chevron-up" style=""></i>
                  </button>

                  <b-form-checkbox v-model="group.active" :indeterminate="group.indeterminate"
                                   @input="toggleGroup(group)" inline>
                    {{ group.name }}
                  </b-form-checkbox>
                </li>

                <b-button-group class='group-btn-actions' size="sm"
                                v-if="group.show && group.actions && group.actions.length > 0">
                  <template v-for="action in group.actions">
                    <b-button @click="executeFunction(action.function, group)" v-bind:key="action.name"
                              v-if="hasPermision(group, action.p)" variant="outline-primary">
                      <i :class="action.icon" aria-hidden="true"></i>
                    </b-button>
                  </template>
                </b-button-group>
                <template v-if="group.show">
                  <li v-for="layer in group.layers" v-bind:key="layer.name" class="sub-item">
                    <switches class='nav-switch' v-model="layer.active" style="margin-top: .5rem;" color="blue"
                              @input="toggleLayer(layer, group)"></switches>
                    <span class='nav-subitem-span'>
                      <img v-if="layer.icon_name" :src='"../../assets/img/icons/" + layer.icon_name + ".png"'
                           height="15" width="15">
                      {{ capitalizeFirstLetter(layer.name) }}
                      <span v-if="layer.count" class="smaller">({{ layer.count.toLocaleString() }})</span>
                    </span>
                  </li>
                </template>
              </template>
            </template>
          </div>

          <template>
            <li class="nav-item" @click="toggleComerciosGoogle">
              <button class="btn btn-empty">
                <i v-if="!showComerciosGoogle" class="fa fa-chevron-down" style=""></i>
                <i v-else class="fa fa-chevron-up" style=""></i>
              </button>
              <span class="btn" style="color: #6b757c;">Externos</span>
            </li>
            <template v-if="showComerciosGoogle">
              <li class="sub-item">
                <switches class='nav-switch' v-model="comerciosGoogle" style="margin-top: .5rem;" color="blue"
                          @input="toggleGoogle"></switches>
                <span>
                Comercios Google
              </span>

              </li>
              <li class="sub-item">
                <switches class='nav-switch' v-model="kmz" style="margin-top: .5rem;" color="blue"
                          @input="toggleKmz"></switches>
                <span>
                Capa archivo KMZ/KML {{ kmzFilename ? '(' + kmzFilename + ')' : '' }}
              </span>

              </li>
              <li class="sub-item btn text-left" @click="openKMLDialog()">
              <span>
                <i class="fa fa-globe"></i> Cargar archivo KML
              </span>
              </li>
            </template>
          </template>

          <template v-if="hasPermision({rol:'GESTION COMERCIAL'}, 'A') || hasPermision({rol:'GESTION COMERCIAL'}, 'V')">
            <li class="nav-item" @click="showGestionComercial = !showGestionComercial">
              <button class="btn btn-empty">
                <i v-if="!showGestionComercial" class="fa fa-chevron-down" style=""></i>
                <i v-else class="fa fa-chevron-up" style=""></i>
              </button>
              <span class="btn" style="color: #6b757c;">Gestión comercial</span>
            </li>
            <template v-if="showGestionComercial">
              <template v-if="hasPermision({rol:'GESTION COMERCIAL'}, 'A')">
                <li style="text-align: left;" class="sub-item btn" @click="manageLotes()"
                    v-if="hasPermision({rol:'GESTION COMERCIAL'}, 'V') || hasPermision({rol:'GESTION COMERCIAL'}, 'A')">
                <span>
                  <i class="fa fa-archive"></i> Lotes
                </span>
                </li>
              </template>
              <template v-else>
                <li class="sub-item btn text-left" @click="manageVisits()">
                <span>
                  <i class="fa fa-bar-chart"></i> Resumen visitas
                </span>
                </li>
                <li class="sub-item btn text-left" @click="manageVisitsEntities()">
                <span>
                  <i class="fa fa-calendar"></i> Visitas entidades
                </span>
                </li>
                <li style="text-align: left;" class="sub-item btn" @click="manageLotes()">
                <span>
                  <i class="fa fa-archive"></i> Lotes
                </span>
                </li>
                <li style="text-align: left;" class="sub-item btn" @click="showPotential()">
                <span>
                  <i class="fa fa-book"></i> Estudio de potencial Residencial
                </span>
                </li>
              </template>
            </template>
          </template>

          <template v-if="hasPermision({rol:'SISTEMA'}, 'B') || hasPermision({rol:'SISTEMA'}, 'V')">
            <li class="nav-item" @click="showSistema = !showSistema">
              <button class="btn btn-empty">
                <i v-if="!showSistema" class="fa fa-chevron-down" style=""></i>
                <i v-else class="fa fa-chevron-up" style=""></i>
              </button>
              <span class="btn" style="color: #6b757c;">Sistema</span>
            </li>
            <template v-if="showSistema">
              <li style="text-align: left;" class="sub-item btn" @click="manageUsers"
                  v-if="hasPermision({rol:'SISTEMA'}, 'V')">
              <span>
                <i class="fa fa-user"></i> Gestión usuarios
              </span>
              </li>
              <li style="text-align: left;" class="sub-item btn" @click="manageAlerts = true"
                  v-if="hasPermision({rol:'SISTEMA'}, 'B')">
              <span>
                <i class="fa fa-exclamation-circle"></i> Gestión alertas
              </span>
              </li>
              <li class="sub-item btn text-left" @click="altaEntidad()">
                <!--v-if="hasPermision({rol:'GESTION COMERCIAL'}, 'B')" -->
                <span>
                <i class="fa fa-pencil-square-o"></i> Gestión entidades
              </span>
              </li>
              <li class="sub-item btn text-left" @click="logsActividad">
                <span>
                  <i class="fa fa-search"></i> Logs de Actividad
                </span>
              </li>
              <li style="text-align: left;" class="sub-item btn" @click="manageCierreLotes"
                  v-if="hasPermision({rol:'SISTEMA'}, 'V')">
              <span>
                <i class="fa fa-archive"></i> Cierre lotes
              </span>
              </li>
            </template>
          </template>
          <li class="btn-navbar" @click="saveVisibility">
          <span class="btn">
            <i class="fa fa-map pl-0 mr-2"></i> Guardar visibilidad</span>
          </li>
          <li class="btn-navbar" @click="savePosition">
          <span class="btn">
            <i class="fa fa-map pl-0 mr-2"></i> Guardar posición actual</span>
          </li>
        </ul>
      </div>
    </div>
    <FilterModal v-if="userLoaded" :style="(filtermodal === 'comercial') ? 'display:initial':'display:none'"
                 :optsfiltros="optsfiltros"
                 :filtros="filtros"
                 ref="filtercomercial"
                 type="comercial">
    </FilterModal>
    <FilterModal v-if="userLoaded" :style="(filtermodal === 'caldera') ? 'display:initial':'display:none'"
                 :optsfiltros="optsfiltroscaldera"
                 :filtros="filtroscaldera"
                 ref="filtercaldera"
                 type="caldera">
    </FilterModal>
    <UsersManagement v-if="showUsersManagement" :permisos="permisos"></UsersManagement>
    <CierreLotesManagement v-if="showCierreLotesManagement" :permisos="permisos"></CierreLotesManagement>
    <ManageAlerts v-if="manageAlerts"></ManageAlerts>
    <LotesPopUp v-if="showLotes" :permisos="permisos" :user="user.username"
                :parentoptsfiltros="optsfiltros" :parentoptsfiltroscaldera="optsfiltroscaldera"
                ref="lotespopup"></LotesPopUp>
    <ManageVisits v-if="showManageVisitsPopup" :permisos="permisos"></ManageVisits>

    <ManageVisitsEntities v-if="showManageVisitsEntitiesPopup" :permisos="permisos"></ManageVisitsEntities>
    <InfoPopUp v-if="showInfoPopUp" :type="infoType"></InfoPopUp>

    <AltaEntidad v-if="showAltaEntidadPopup"></AltaEntidad>

    <LogsActividad v-if="showLogsActividad"></LogsActividad>

    <Notifications v-if="showNotifications" :notifications="notifications" :alert="false"></Notifications>
    <Notifications v-if="showAlerts" :notifications="alerts" :alert="true"></Notifications>

    <b-modal id="generic" ref="genericmodal" ok-only>
      <p class="my-4">{{ textgeneric }}</p>
    </b-modal>

    <div v-if="PotentialResults">
      <PotentialResults @hide="hidePotential2" :geom_geojson="geom_geojson"></PotentialResults>
    </div>

  </b-navbar>
</template>

<style>
.smaller {
  font-size: smaller;
}

.sidebar {
  background: white;
  border-right: 1px solid #ccccccab;
  height: 100%;
  left: 0;
  overflow-x: hidden;
  position: fixed;
  transition: 0.5s;
  top: 0;
  width: 0;
  z-index: 3;
}

.sidebar-container {
  padding: 1rem;
}

.absolute-div {
  position: absolute;
  top: 60px;
  right: 60px;
  z-index: 3;
  width: calc(100% - 400px);
}

.group-btn-actions {
  padding-left: 2em;
  margin-top: 1em;
  margin-bottom: 0.5em;
}

.etiquetas-btn {
  padding-left: 2em;
}

.section-group-collapse li.sub-item:last-child {
  margin-bottom: 2em;
}

</style>

<script>
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import HelpSidePanel from '@/components/Layout/HelpSidePanel.vue';
import {sidePanelData} from './sidePanelData';
import Switches from 'vue-switches';
import Multiselect from 'vue-multiselect';
import Tag from '@/components/Layout/Tag.vue';
import checkBox from '@/components/Modules/Misc/checkBox.vue';
import searchBar from '@/components/Layout/SearchBar.vue';
import FilterModal from '@/components/Layout/FilterModal.vue';
import LotesPopUp from './LotesPopUp';
import ManageVisits from './CommercialManagement/ManageVisits';
import ManageVisitsEntities from './CommercialManagement/ManageVisitsEntities';
import AltaEntidad from './CommercialManagement/AltaEntidad';
import InfoPopUp from '@/components/Layout/InfoPopUp.vue';
import Notifications from '@/components/Layout/Notifications.vue';
import ManageAlerts from '@/components/Layout/ManageAlerts.vue';
import PotentialResults from '@/components/Modules/PotentialResults.vue';
import UsersManagement from './SystemManagement/users-management/UsersManagement';
import CierreLotesManagement from './SystemManagement/cierre-lotes-management/CierreLotesManagement';
import LogsActividad from './SystemManagement/logs-management/LogsActividad';
import {PublicClientApplication} from '@azure/msal-browser';

const ReconnectingWebSocket = require('reconnecting-websocket');
Vue.use(VueCookie);

export default {
  name: 'navbar',
  props: ['permisos'],
  components: {
    PotentialResults,
    HelpSidePanel,
    Switches,
    checkBox,
    Notifications,
    searchBar,
    FilterModal,
    LotesPopUp,
    UsersManagement,
    CierreLotesManagement,
    LogsActividad,
    ManageAlerts,
    InfoPopUp,
    ManageVisits,
    ManageVisitsEntities,
    AltaEntidad,
    'multiselect': Multiselect,
    'tag': Tag
  },
  data: function () {
    return {
      supportEmail: process.env.SUPPORT_EMAIL,
      PotentialResults: false,
      geom_geojson: null,
      drawing: false,
      isComercialFiltered: false,
      isCalderaFiltered: false,
      showComerciosGoogle: false,
      manageAlerts: false,
      comerciosGoogle: false,
      kmz: false,
      kmzFilename: '',
      showNotifications: false,
      showAlerts: false,
      alerts: [],
      notifications: [],
      userLoaded: false,
      comercialLabels: false,
      ishover: false,
      showManageComercial: false,
      showLotes: false,
      showSistema: false,
      showGestionComercial: false,
      showGestionEntidades: false,
      showUsersManagement: false,
      showCierreLotesManagement: false,
      showManageVisitsPopup: false,
      showManageVisitsEntitiesPopup: false,
      showAltaEntidadPopup: false,
      showLogsActividad: false,
      help: false,
      layers: false,
      textgeneric: '',
      user: {
        username: 'Perfil'
      },
      filtermodal: false,
      ayuda: sidePanelData,
      checked: true,
      indeterminate: true,
      tmpprovincia: '',
      comercial: {
        name: 'Comercial',
        styles: '',
        layer_name: 'geovisor:comercial',
        show: false,
        rol: 'COMERCIAL',
        active: false,
        indeterminate: false,
        layers: [],
        filter: {},
        filter_name: 'id_categoria_gn_comercial',
        layer: null,
        zindex: 102,
        actions: [
          {name: 'Filtrar', icon: 'fa fa-filter', function: 'showModal', p: 'V'},
          {name: 'Descargar', icon: 'fa fa-download', function: 'downloadExcel', p: 'X'},
          {name: 'Crear', icon: 'fa fa-plus', function: 'newComercial', p: 'E'},
          {name: 'Info', icon: 'fa fa-info', function: 'openInfo', p: 'V'}
        ]
      },
      caldera: {
        name: 'Caldera centralizada',
        styles: '',
        layer_name: 'geovisor:caldera',
        show: false,
        rol: 'CALDERA CENTRALIZADA',
        active: false,
        indeterminate: false,
        layers: [],
        filter: {},
        filter_name: 'id_categoria_gn_caldera',
        layer: null,
        zindex: 102,
        actions: [
          {name: 'Filtrar', function: 'showModal', icon: 'fa fa-filter', p: 'V'},
          {name: 'Descargar', function: 'downloadExcel', icon: 'fa fa-download', p: 'X'},
          {name: 'Info', icon: 'fa fa-info', function: 'openInfo', p: 'V'}
        ]
      },
      filtros: {
        id_tipo_establecimiento_gn_comercial: [],
        id_clase_establecimiento_gn_comercial: [],
        id_status_gestion_comercial: [],
        motivo_no_potencial: null,
        id_gas_finca: [],
        in_service_mains_distance: null,
        provincia: [],
        municipio: [],
        cliente: null,
        visitado_gestor: [],
        id_categoria_gn_comercial: [],
        conclientes: null
      },
      filtroscaldera: {
        id_status_gestion_caldera: [],
        motivo_no_potencial: null,
        id_gas_finca: [],
        in_service_mains_distance: null,
        provincia: [],
        municipio: [],
        cliente: null,
        visitado_gestor: [],
        id_categoria_gn_comercial: [],
        conclientes: null
      },
      optsfiltros: {
        initFilters: true,
        id_tipo_establecimiento_gn_comercial: [],
        id_clase_establecimiento_gn_comercial: [],
        id_categoria_gn_comercial: [],
        id_status_gestion: [],
        motivo_no_potencial: [],
        id_gas_finca: ['Sí', 'No', 'Desconocido'],
        in_service_mains_distance: [{id: null, label: 'Todos'}, {id: '12', label: '< 12m'}, {
          id: '25',
          label: '< 25m'
        }, {id: '50', label: '< 50m'}, {id: '100', label: '< 100m'}, {id: '150', label: '< 150m'}, {
          id: '200',
          label: '< 200m'
        }, {id: '250', label: '< 250m'}],
        cliente: [{id: true, text: 'Sí'}, {id: false, text: 'No'}],
        visitado_gestor: ['Sí por mí', 'Sí por otros', 'Ninguno'],
        provincia: [],
        municipio: []
      },
      infoType: null,
      showInfoPopUp: false,
      optsfiltroscaldera: {
        initFilters: true,
        id_tipo_establecimiento_gn_caldera: [],
        id_clase_establecimiento_gn_caldera: [],
        id_categoria_gn_caldera: [],
        id_status_gestion: [],
        motivo_no_potencial: [],
        id_gas_finca: ['Sí', 'No', 'Desconocido'],
        in_service_mains_distance: [{id: '12', label: '< 12m'}, {id: '25', label: '< 25m'}, {
          id: '50',
          label: '< 50m'
        }, {id: '100', label: '< 100m'}, {id: '150', label: '< 150m'}, {id: '200', label: '< 200m'}, {
          id: '250',
          label: '< 250m'
        }],
        cliente: [{id: true, text: 'Sí'}, {id: false, text: 'No'}],
        visitado_gestor: ['Sí por mí', 'Sí por otros', 'Ninguno'],
        provincia: [],
        municipio: []
      },
      socket: null
    };
  },
  methods: {

    openKMLDialog: function () {
      document.getElementsByClassName('leaflet-control-filelayer leaflet-control-zoom-in leaflet-bar-part')[0].click();
    },
    showPotentialResults: function () {
      this.geom_geojson = this.getLayersJSON();
      // this.$emit('draw')
      this.drawing = false;
      this.PotentialResults = true;
    },
    hidePotential: function () {
      // this.$emit('draw')
      this.drawing = false;
      this.PotentialResults = false;
      this.removeLayers();
    },
    hidePotential2: function () {
      this.$parent.drawFlag = false;
      this.drawing = false;
      this.PotentialResults = false;
      this.removeLayers();
    },
    removeLayers () {
      for (let i in this.$parent.map.drawerLayers) {
        let layer = this.$parent.map.drawerLayers[i];
        this.$parent.map.map.removeLayer(layer);
        delete this.$parent.map.drawerLayers[i];
      }
      this.$parent.map.drawerLayers = [];
    },
    getLayersJSON () {
      // var geojsonarray = []
      // for (let i in this.$parent.map.drawerLayers) {
      //   let layer = this.$parent.map.drawerLayers[i]
      //   geojsonarray.push(JSON.stringify(layer.toGeoJSON().geometry))
      // }
      return this.$parent.getLayersJSON();
    },
    showPotential: function () {
      this.$parent.showPotentialFlag = true;
      this.$parent.drawFlag = true;
      this.drawing = false;
      // this.$parent.addPolygon()
    },
    toggleComerciosGoogle: function () {
      this.showComerciosGoogle = !this.showComerciosGoogle;
    },
    toggleGoogle: function () {
      this.$emit('toggleGoogle', this.comerciosGoogle);
    },
    toggleKmz: function () {
      this.$emit('toggleKmz', this.kmz);
    },
    capitalizeFirstLetter: function (string) {
      string = string.toLowerCase();
      let text = string.charAt(0).toUpperCase() + string.slice(1);
      text = text.replace('nedgia', 'Nedgia');
      text = text.replace('irc', 'IRC');
      text = text.replace('glp', 'GLP');
      text = text.replace('gnl', 'GNL');
      return text;
    },
    ShowTerritorio: function (layer) {
      var noGN = [
        'geovisor:zona_gn',
        'geovisor:provincia',
        'geovisor:municipio',
        'geovisor:codigo_postal',
        'geovisor:seccion_censal',
        'geovisor:nucleo_urbano'
      ];

      var GN = [
        'geovisor:territorio_gn_derechos_alta',
        'geovisor:territorio_gn_canon_irc',
        'geovisor:territorio_gn'
      ];

      if (noGN.indexOf(layer.layer_name) > -1) {
        return this.permisos['TERRITORIO NO GN']['V'];
      } else if (GN.indexOf(layer.layer_name) > -1) {
        return this.permisos['TERRITORIO GN']['V'];
      } else {
        return true;
      }
    },
    hideAlerts: function () {
      this.showAlerts = false;
      this.loadNotifications();
    },
    deleteNotification: function (n, alert) {
      var url = '';
      if (alert) {
        url = 'alertas/';
        this.alerts = this.alerts.filter(e => e.id !== n.id);
      } else {
        url = 'notificaciones/';
        this.notifications = this.notifications.filter(e => e.id !== n.id);
      }
      this.$http.delete(url + n.id + '/').then(result => {

      });
    },
    toggleLabel: function (group) {
      var layer = this.comercial;

      if (layer.styles === '') {
        layer.styles = 'AA_comercial_label';
        layer.tiled = false;
      } else {
        layer.styles = '';
        layer.tiled = true;
      }

      this.$parent.disableLayer(layer);
      layer.layer = this.$parent.createLayer(layer);

      var list = layer.layers.filter(e => e.active).map(e => e.id);
      if (list.length) {
        this.setFilter(layer, layer.filter_name, list);
      }
    },
    openInfo: function (type) {
      this.infoType = type;
      this.showInfoPopUp = true;
    },
    manageLotes: function () {
      this.showLotes = true;
    },
    manageVisits: function () {
      this.showManageVisitsPopup = true;
    },
    manageVisitsEntities: function () {
      this.showManageVisitsEntitiesPopup = true;
    },
    closeManageVisits: function () {
      this.showManageVisitsPopup = false;
    },
    closeManageVisitsEntities: function () {
      this.showManageVisitsEntitiesPopup = false;
    },
    altaEntidad: function () {
      this.showAltaEntidadPopup = true;
    },
    closeAltaEntidad: function () {
      this.showAltaEntidadPopup = false;
    },
    manageUsers: function () {
      this.showUsersManagement = true;
    },
    manageCierreLotes: function () {
      this.showCierreLotesManagement = true;
    },
    logsActividad: function () {
      this.showLogsActividad = true;
    },
    hasPermision: function (group, p) {
      if (group.name === 'Territorio') {
        return (this.permisos['TERRITORIO GN'][p] || this.permisos['TERRITORIO NO GN'][p]);
      } else {
        if (group.test && (window.location.hostname === 'geovisor.kernel-analytics.com' || window.location.hostname === 'geovisor.nedgia.es')) {
          return false;
        } else {
          if (group.rol) {
            return this.permisos[group.rol][p];
          } else {
            return false;
          }
        }
      }
    },
    clearFilter: function (type = null) {
      if (type === 'comercial') {
        this.filtros = {
          id_tipo_establecimiento_gn_comercial: [],
          id_clase_establecimiento_gn_comercial: [],
          id_status_gestion_comercial: [],
          motivo_no_potencial: null,
          id_gas_finca: [],
          in_service_mains_distance: null,
          provincia: [],
          municipio: [],
          cliente: null,
          visitado_gestor: [],
          id_categoria_gn_comercial: [],
          conclientes: null
        };
        this.optsfiltros.id_tipo_establecimiento_gn_comercial = [];

        let layer = this[type];

        let currentLabelsSelected = layer.filter.id_categoria_gn_comercial;

        layer.filter = {'id_categoria_gn_comercial': currentLabelsSelected};
        this.applyFilter('comercial', true);
        // this.reloadLayer(layer)
      } else if (type === 'caldera') {
        this.filtroscaldera = {
          id_status_gestion_caldera: [],
          motivo_no_potencial: null,
          id_gas_finca: [],
          in_service_mains_distance: null,
          provincia: [],
          municipio: [],
          cliente: null,
          visitado_gestor: [],
          id_categoria_gn_comercial: [],
          conclientes: null
        };
        let layer = this[type];

        let currentLabelsSelected = layer.filter.id_categoria_gn_caldera;

        layer.filter = {'id_categoria_gn_caldera': currentLabelsSelected};
        // layer.filter = {}
        this.applyFilter('caldera', true);

        // this.reloadLayer(layer)
      }
    },
    setFilter: function (layer, key, value, type = null, end = false) {
      if ((layer.filter[key] ? layer.filter[key] : []).toString() !== value.toString()) {
        if (value.length === 0) {
          delete layer.filter[key];
        } else if (!value) {
          delete layer.filter[key];
        } else {
          layer.filter[key] = value;
          if (type) {
            layer.filter[key]['type'] = type;
          }
          if (end) {
            layer.filter[key]['end'] = end;
          }
        }
        this.$parent.disableLayer(layer);

        layer.layer = this.$parent.createLayer(layer);
      }

      if (layer.active) {
        this.$parent.enableLayer(layer);
      }
    },
    setFilterModal (layer, key, value, type = null, end = false) {
      try {
        if ((layer.filter[key] ? layer.filter[key] : []).toString() !== value.toString()) {
          if (value.length === 0) {
            delete layer.filter[key];
          } else if (!value) {
            delete layer.filter[key];
          } else if (value === '\'null\'' || value === 'null') {
            delete layer.filter[key];
          } else {
            if (type || end) {
              layer.filter[key] = {};
              layer.filter[key]['end'] = end;
              layer.filter[key]['type'] = type;
              layer.filter[key]['value'] = value;
            } else {
              layer.filter[key] = value;
            }
          }
        }
      } catch (err) {
        // When try clear filters not applied
      }
    },
    reloadLayer (layer) {
      this.$parent.disableLayer(layer);
      layer.layer = this.$parent.createLayer(layer);
      if (layer.active) {
        this.$parent.enableLayer(layer);
      }
    },
    applyCountParams: function (type, params) {
      var layer = this[type];
      layer.countParams = params;
    },
    applyFilter (type = null, reload = true) {
      var clone = null;
      if (type === 'comercial') {
        clone = Object.assign({}, this.filtros);
      } else if (type === 'caldera') {
        clone = Object.assign({}, this.filtroscaldera);
        clone.id_gas_en_finca = clone.id_gas_finca;
        delete clone.id_gas_finca;
      }
      var parsed = null;
      var layer = this[type];

      for (var f in clone) {
        var value = clone[f];

        if (Array.isArray(value) && f === 'id_tipo_establecimiento_gn_comercial') {
          let idSubcats = [];
          parsed = value.map(v => v.id);
          for (let index = 0; index < parsed.length; index++) {
            const element = parsed[index];
            if (isNaN(element) && element.indexOf('Todas ') > -1) {
              let idCat = parseInt(element.split('Todas ')[1]);
              let subcats = this.optsfiltros.id_tipo_establecimiento_gn_comercial.filter(v => v.id_categoria_gn_comercial !== undefined && v.id_categoria_gn_comercial.id === idCat);
              idSubcats = [...idSubcats, ...subcats.map(v => v.id)];
            } else {
              idSubcats = [...idSubcats, element];
            }
          }
          this.setFilterModal(layer, f, idSubcats);
        } else if (Array.isArray(value) && f !== 'provincia' && f !== 'id_categoria_gn_comercial') {
          parsed = value.map(v => v.id);
          this.setFilterModal(layer, f, parsed);
        } else if (Array.isArray(value) && f === 'provincia') {
          parsed = value.map(v => `'${v}'`);
          this.setFilterModal(layer, f, parsed);
        } else if (value && value.hasOwnProperty('id') && f !== 'in_service_mains_distance') {
          this.setFilterModal(layer, f, `'${value.id}'`);
        } else if (f !== 'id_categoria_gn_comercial' && f !== 'id_tipo_establecimiento_gn_comercial') {
          this.setFilterModal(layer, f, `'${value}'`);
        }
      }

      if (clone['in_service_mains_distance'] && clone['in_service_mains_distance'].hasOwnProperty('id')) {
        let v = clone['in_service_mains_distance'];
        this.setFilterModal(layer, 'in_service_mains_distance', parseInt(v.id), '<', false);
      }
      var queryvisitado = this.parsedFilterVisitadoGestor(clone);
      if (queryvisitado) {
        this.setFilterModal(layer, 'visitado_gestor', queryvisitado, null, true);
      }
      // var querycategorias = this.parsedTipoCategoriaComercial(clone)
      // if (querycategorias) {
      //   this.setFilterModal(layer, 'id_categoria_gn_comercial', querycategorias, null, true)
      // }

      if (reload) {
        this.reloadLayer(layer);
      }
      if (layer.name === 'Comercial' || layer.name === 'Caldera centralizada') {
        this.checkFilter(layer);
        if (layer.name === 'Comercial') {
          this.$refs.filtercomercial.applyCount();
        } else {
          this.$refs.filtercaldera.applyCount();
        }
        this.getCountComercial(layer.layer_name);
      }
    },
    checkFilter: function (layer) {
      if (layer.name === 'Comercial') {
        this.isComercialFiltered = (Object.keys(layer.filter).filter(v => v !== 'id_categoria_gn_comercial').length > 0);
      } else {
        this.isCalderaFiltered = (Object.keys(layer.filter).filter(v => v !== 'id_categoria_gn_caldera').length > 0);
      }
    },
    parsedTipoCategoriaComercial (filtros) {
      var query = [];
      var categorias = [];
      var tipos = [];
      if (filtros.id_tipo_establecimiento_gn_comercial) {
        if (filtros.id_tipo_establecimiento_gn_comercial.length) {
          for (let i in filtros.id_tipo_establecimiento_gn_comercial) {
            let com = filtros.id_tipo_establecimiento_gn_comercial[i];
            if (com.id.toString().includes('Todas ')) {
              var id = parseInt(com.id.substring('Todas '.length, com.id.length));
              categorias.push(id);
            } else {
              tipos.push(com.id);
            }
          }
        }
      }

      if (tipos.length) {
        query.push('id_tipo_establecimiento_gn_comercial IN (' + tipos.join(',') + ')');
      }
      if (categorias.length) {
        query.push('id_categoria_gn_comercial IN (' + categorias.join(',') + ')');
      }
      if (query.length) {
        return '(' + query.join(' OR ') + ')';
      }
      return null;
    },
    setFilterRegion () {
      var todasprovincias = [];
      this.municipios = [];
      for (var provincia in this.filtros.provincia) {
        if (this.filtros.provincia[provincia].length > 0 && this.filtros.provincia[provincia][0] === '__todos__') {
          todasprovincias.push(provincia);
        } else if (this.filtros.provincia[provincia].length > 0) {
          for (var m in this.filtros.provincia[provincia]) {
            var municipio = this.filtros.provincia[provincia][m];
            this.municipios.push(municipio);
          }
        }
      }
      // var raw_query__provincias = 'provincia in (' + todasprovincias.join() + ')'
    },
    parsedFilterVisitadoGestor (filtros) {
      var queryvisitador = [];
      for (var i in filtros.visitado_gestor) {
        var visitadogestor = filtros.visitado_gestor[i];
        if (visitadogestor === 'Sí por mí') {
          queryvisitador.push('(codigo_visitador like \'%' + this.user.username + '%\')');
        } else if (visitadogestor === 'Sí por otros') {
          queryvisitador.push('(codigo_visitador not like \'%' + this.user.username + '%\')');
        } else {
          queryvisitador.push('codigo_visitador=\'\'');
        }
      }
      if (queryvisitador.length) {
        return '(' + queryvisitador.join(' OR ') + ')';
      }
      return null;
    },
    toggleComercialLayer: function (checked, i, g) {
      if (checked) {
        this.$set(g, 'active', checked);
      }

      this.$set(g.layers[i], 'active', checked);

      this.setGroupCheckbox(g);
      var list = g.layers.filter(e => e.active).map(e => e.id);

      if (list.length) {
        this.setFilter(g, g.filter_name, list);
        // this.$parent.enableLayer(g)
      } else {
        this.$parent.disableLayer(g);
      }
    },
    toggleComercialGroup: function (checked, g) {
      var layer = null;
      if (!checked) {
        for (let index = 0; index < g.layers.length; index++) {
          layer = g.layers[index];
          layer.active = false;
        }
        this.$parent.disableLayer(g);
      } else {
        g.active = true;

        for (let index = 0; index < g.layers.length; index++) {
          layer = g.layers[index];
          layer.active = true;
        }

        // this.$parent.enableLayer(g)
        var list = g.layers.map(e => e.id);
        this.setFilter(g, g.filter_name, list);
      }
      g.indeterminate = false;
    },
    checkboxToggled (checked, municipio) {
      if (checked) {
        this.addProvincia();
        this.addMunicipio(municipio);
      } else {
        this.removeMunicipio(municipio);
        this.removeProvincia();
      }
    },
    removeMunicipio (municipio) {
      try {
        var id = this.filtros.provincia[this.tmpprovincia].indexOf(municipio);
        if (id > -1) {
          this.filtros.provincia[this.tmpprovincia].splice(id, 1);
        }
        this.$refs['checkbox_municipio_' + municipio][0].externalToggle(false);
        this.$refs.tags.setProvincias(this.filtros.provincia);
      } catch (err) {
      }
    },
    addMunicipio (municipio) {
      var i = this.filtros.provincia[this.tmpprovincia].indexOf(municipio);
      if (i === -1) {
        this.filtros.provincia[this.tmpprovincia].push(municipio);
      }
      if (this.filtros.provincia[this.tmpprovincia].length === this.optsfiltros.municipio.length) {
        this.filtros.provincia[this.tmpprovincia] = ['__todos__'];
        this.$refs.checkboxtodosmunicipios.externalToggle(true);
      }
      this.$refs.tags.setProvincias(this.filtros.provincia);
    },
    checkboxTodosMunicipiosToggle (checked) {
      if (checked) {
        this.addProvincia(true);
        this.getCheckboxMunicipio();
      } else if (!checked) {
        this.removeProvincia(true);
        this.getCheckboxMunicipio(false);
      }
    },
    getCheckboxMunicipio (check = true) {
      for (var m in this.optsfiltros.municipio) {
        var municipio = this.optsfiltros.municipio[m].entity_name;
        if (this.$refs['checkbox_municipio_' + municipio][0].isChecked()) {
          this.removeMunicipio(municipio);
        }
        this.$refs['checkbox_municipio_' + municipio][0].externalToggle(check);
      }
    },
    addOtherMunicipios () {
      for (var m in this.optsfiltros.municipio) {
        var municipio = this.optsfiltros.municipio[m].entity_name;
        if (this.$refs['checkbox_municipio_' + municipio][0].isChecked()) {
          this.addMunicipio(municipio);
        }
      }
    },
    toggleGroup: function (g) {
      var layer = null;
      // TODO mun_red_desplaza raise exception when disable it
      if (!g.active) {
        for (let index = 0; index < g.layers.length; index++) {
          layer = g.layers[index];
          layer.active = false;
          this.$parent.disableLayer(layer);
        }
      } else {
        for (let index = 0; index < g.layers.length; index++) {
          layer = g.layers[index];
          if (!layer.catastro) {
            layer.active = true;
            this.$parent.enableLayer(layer);
          }
        }
      }
      g.indeterminate = false;
    },
    toggleGroupOptions: function (g) {
      g.show = !g.show;
    },
    isActive: function (l) {
      return true;
    },
    toggleHelp () {
      this.help = !this.help;
      this.$refs.helpPanel.toggle();
    },
    toggleLayer: function (l, g) {
      // This function activates and deactivates a layer. First, through the navbar set true or false to the active property and
      // then this function will be executed. After icon checkbox of group layers will be changed.
      if (!l.active) {
        this.$parent.disableLayer(l);
      } else {
        this.$parent.enableLayer(l);
      }

      this.setGroupCheckbox(g);
    },
    setGroupCheckbox: function (g) {
      if (g.name === 'Territorio') {
        let v = 0;
        let territorioLayers = g.layers.filter(c => this.ShowTerritorio(c));
        for (let index = 0; index < territorioLayers.length; index++) {
          const element = territorioLayers[index];
          if (element.active) {
            v = v + 1;
          }
        }

        // When the territorio group checkbox is enabled, we enable all layers but the ones with catastro:true.
        // So, a saved visibility with all Territorio layers enabled (but the catastro ones) means the checkbox should be enabled rather than indeterminated.
        let notCatastroItems = territorioLayers.filter(c => c.catastro === undefined).length;

        if (v === notCatastroItems) {
          g.indeterminate = false;
          g.active = true;
        } else {
          if (v < territorioLayers.length && v > 0) {
            g.indeterminate = true;
          } else {
            g.indeterminate = false;
            if (v === 0) {
              g.active = false;
            }
          }
        }
      } else {
        let v = 0;
        for (let index = 0; index < g.layers.length; index++) {
          const element = g.layers[index];
          if (element.active) {
            v = v + 1;
          }
        }
        if (v < g.layers.length && v > 0) {
          g.indeterminate = true;
        } else {
          g.indeterminate = false;
          if (v === 0) {
            g.active = false;
          } else if (v === g.layers.length) {
            g.active = true;
          }
        }
      }
    },
    toggleLayers () {
      this.layers = !this.layers;
      if (this.layers) {
        this.$refs.layersPanel.style.width = '316px';
      } else {
        this.$refs.layersPanel.style.width = '0px';
      }
    },
    setLayers (value) {
      this.layers = value;
      if (this.layers) {
        this.$refs.layersPanel.style.width = '315px';
      } else {
        this.$refs.layersPanel.style.width = '0px';
      }
    },
    gotoUsers: function () {
      this.$router.push({name: 'Users'});
    },

    logout: async function () {
      document.cookie =
        'kernel_token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
      const msalInstance = this.msalInstance || new PublicClientApplication({
        auth: {
          clientId: process.env.ENTRA_CLIENT_ID,
          authority: process.env.ENTRA_AUTHORITY,
          redirectUri: process.env.ENTRA_REDIRECT_URI,
          knownAuthorities: ['login.microsoftonline.com']
        }
      });

      try {
        await msalInstance.logoutPopup();
      } catch (e) {
        console.warn('Error en logoutPopup:', e);
      }
      document.location.replace('/');
    },
    user_info: function () {
      this.$router.push({name: 'UserInfo', params: {id: this.user.id}});
    },
    showModal (type = null) {
      this.filtermodal = type;
      this.$refs.filtercomercial.show();
      this.$refs.filtercaldera.show();
    },
    cancellotesPopUp () {
      this.$refs.lotespopup.showModal(true);
    },
    acceptlotesPopUp () {
      // this.showLotes = true
      this.$refs.lotespopup.filterArea();
    },
    closeModal () {
      this.filtermodal = false;
    },
    executeFunction (functionstring, type) {
      this[functionstring](type);
    },
    getMunicipios (value) {
      this.$http.get('geomunicipio', {
        params: {
          cod_gas_provincia__entity_name: value,
          ordering: 'entity_name',
          not_paginated: false
        }
      }).then(response => {
        this.optsfiltros.municipio = response.body;
      });
    },
    addProvincia (todos = false) {
      if (this.filtros.provincia[this.tmpprovincia] === undefined) {
        this.filtros.provincia[this.tmpprovincia] = [];
      }
      if (todos) {
        this.filtros.provincia[this.tmpprovincia].push('__todos__');
      }
      this.$refs.tags.setProvincias(this.filtros.provincia);
    },
    removeProvincia (todos = false) {
      if (this.filtros.provincia[this.tmpprovincia]) {
        if (this.filtros.provincia[this.tmpprovincia].length === 0) {
          delete this.filtros.provincia[this.tmpprovincia];
        } else if (todos && this.filtros.provincia[this.tmpprovincia][0] === '__todos__') {
          delete this.filtros.provincia[this.tmpprovincia];
        } else if (this.filtros.provincia[this.tmpprovincia][0] === '__todos__') {
          this.filtros.provincia[this.tmpprovincia].shift();
          this.addOtherMunicipios();
          this.$refs.checkboxtodosmunicipios.externalToggle(false);
        }
        this.$refs.tags.setProvincias(this.filtros.provincia);
      }
    },
    removeProvinciaExt (provincia) {
      if (this.filtros.provincia[provincia]) {
        delete this.filtros.provincia[provincia];
      }
      this.$refs.tags.setProvincias(this.filtros.provincia);
    },
    removeMunicipioExt (data) {
      if (this.filtros.provincia[data.provincia]) {
        var id = this.filtros.provincia[data.provincia].indexOf(data.municipio);
        if (id > -1) {
          this.filtros.provincia[data.provincia].splice(id, 1);
        }
        if (this.filtros.provincia[data.provincia].length === 0) {
          delete this.filtros.provincia[data.provincia];
        }
        this.$refs.tags.setProvincias(this.filtros.provincia);
      }
    },
    resetTodos () {
      this.$refs.checkboxtodosmunicipios.reset();
    },
    initialCheckedMunicipio (municipio) {
      if (this.filtros.provincia[this.tmpprovincia]) {
        if (this.filtros.provincia[this.tmpprovincia].indexOf(municipio) > -1) {
          return true;
        } else if (this.filtros.provincia[this.tmpprovincia][0] === '__todos__') {
          return true;
        }
      }
      return false;
    },
    downloadExcel (type = null) {
      var q = this.queryfilters(type);
      var path = {name: 'Download'};
      if (Object.keys(q).length) {
        path['query'] = {'q': q, 'type': type};
      }
      let routeData = this.$router.resolve(path);
      window.open(routeData.href, '_blank');
    },
    newComercial: function () {
      this.setLayers(false);
      this.$emit('newComercial');
    },
    queryfilters (type) {
      var layer = this[type];
      var cqlfilter = this.$parent.getArrayCql(layer);
      return cqlfilter.join(' AND ');
    },
    saveVisibility () {
      var lnames = {};
      var mycopylayers = this.layersList.slice(0);
      mycopylayers.push(this.comercial);
      mycopylayers.push(this.caldera);

      for (let i = 0; i < mycopylayers.length; i++) {
        var group = mycopylayers[i];
        if (!group.layers) {
          continue;
        }
        for (let j in group.layers) {
          var layer = mycopylayers[i].layers[j];
          if (group.name === 'Comercial') {
            lnames[layer.categoria_gn_comercial] = layer.active;
          } else if (group.name === 'Caldera centralizada') {
            lnames[layer.categoria_gn_caldera] = layer.active;
          } else if (group.name === 'Territorio') {
            if (layer.name === 'Catastro transparente' && layer.layer_name === 'CATASTRO') {
              lnames['catastro_transparente'] = layer.active;
            } else if (layer.name === 'Catastro opaco' && layer.layer_name === 'CATASTRO') {
              lnames['catastro_opaco'] = layer.active;
            } else {
              lnames[layer.layer_name] = layer.active;
            }
          } else {
            lnames[layer.layer_name] = layer.active;
          }
        }
      }
      lnames['comercios_google'] = this.comerciosGoogle;

      var th = this;

      this.$http.post('visibilidad/', {'usuario': this.user.id, 'layer': JSON.stringify(lnames)}).then(result => {
        th.textgeneric = 'Se ha guardado correctamente';
        th.$refs.genericmodal.show();
      }).catch(error => {
        console.log(error);
        th.textgeneric = 'Ha ocurrido un error';
        th.$refs.genericmodal.show();
      });
    },
    savePosition () {
      var th = this;

      var map = this.$parent.map.map;
      var latlng = map.getCenter();

      this.$http.post('vistas_mapa/', {
        'usuario_id': this.user.id.toString(),
        zoom: map._zoom,
        x: latlng.lng,
        y: latlng.lat
      }).then(result => {
        th.textgeneric = 'Se ha guardado correctamente';
        th.$refs.genericmodal.show();
      }).catch(error => {
        console.log(error);
        th.textgeneric = 'Ha ocurrido un error';
        th.$refs.genericmodal.show();
      });
    },
    getVisibility (cb) {
      if (this.user.id !== undefined) {
        return this.$http.get('visibilidad/', {params: {usuario: this.user.id}}).then(r => {
          if (r.body.results.length > 0) {
            this.setVisibility(JSON.parse(r.body.results[0].layer));
            cb();
            // this.showActiveLayersMap()
          } else {
            cb();
          }
        });
      } else {
        setTimeout(() => {
          this.getVisibility(cb);
        }, 1000);
      }
      // var th = this
    },

    showActiveLayersMap () {
      if (this.comercial.active) {
        let listComercial = this.comercial.layers.filter(e => e.active).map(e => e.id);

        if (listComercial.length) {
          this.setFilter(this.comercial, this.comercial.filter_name, listComercial);
        }
      }

      if (this.caldera.active) {
        let listCaldera = this.caldera.layers.filter(e => e.active).map(e => e.id);

        if (listCaldera.length) {
          this.setFilter(this.caldera, this.caldera.filter_name, listCaldera);
        }
      }
    },
    setVisibility (listvisibility) {
      // TODO: Check permissions
      var mycopylayers = this.layersList.slice(0);
      mycopylayers.push(this.comercial);
      mycopylayers.push(this.caldera);

      for (let i = 0; i < mycopylayers.length; i++) {
        var group = mycopylayers[i];
        if (!group.layers) {
          continue;
        }
        for (let j in group.layers) {
          var layer = mycopylayers[i].layers[j];
          if (group.name === 'Comercial') {
            // debugger
            let indexComercial = this.comercial.layers.findIndex(f => f.categoria_gn_comercial === layer.categoria_gn_comercial);
            this.toggleComercialLayer(listvisibility[layer.categoria_gn_comercial], indexComercial, this.comercial);
            // layer.active = listvisibility[layer.categoria_gn_comercial]
          } else if (group.name === 'Caldera centralizada') {
            let indexCaldera = this.caldera.layers.findIndex(f => f.categoria_gn_caldera === layer.categoria_gn_caldera);
            this.toggleComercialLayer(listvisibility[layer.categoria_gn_caldera], indexCaldera, this.caldera);
            // layer.active = listvisibility[layer.categoria_gn_caldera]
          } else if (group.name === 'Territorio') {
            if (layer.name === 'Catastro transparente' && layer.layer_name === 'CATASTRO') {
              layer.active = listvisibility['catastro_transparente'];
            } else if (layer.name === 'Catastro opaco' && layer.layer_name === 'CATASTRO') {
              layer.active = listvisibility['catastro_opaco'];
            } else {
              layer.active = listvisibility[layer.layer_name] || false;
            }
          } else {
            layer.active = listvisibility[layer.layer_name] || false;
          }
        }
        this.setGroupCheckbox(group);
      }

      if (listvisibility.comercios_google) {
        this.comerciosGoogle = listvisibility.comercios_google;
        this.toggleGoogle();
      }
    },
    getCountComercial: function (name) {
      var tmp = this.comercial;
      if (name !== 'geovisor:comercial') {
        tmp = this.caldera;
      }

      for (let index = 0; index < tmp.layers.length; index++) {
        const layer = tmp.layers[index];

        // Test
        var params = {};
        if (tmp.countParams) {
          params = tmp.countParams;
        }

        if (name !== 'geovisor:comercial') {
          params['id_categoria_gn_caldera'] = layer.id;
        } else {
          params['id_categoria_gn_comercial'] = layer.id;
        }

        this.$http.post('count/', {params: params}).then(result => {
          layer.count = result.data.count;
        });
      }
    },
    getComercialTerritorioLayers: function () {
      return Promise.all([
        this.$http.get('categorias_gn_comercial/', {params: {not_paginated: true}}),
        this.$http.get('categorias_gn_caldera/', {params: {not_paginated: true}})
      ]).then(results => {
        for (let index = 0; index < results[0].data.length; index++) {
          results[0].data[index].active = false;
          results[0].data[index].count = 0;
        }

        this.comercial.layers = results[0].data;

        if (this.hasPermision(this.comercial, 'V')) {
          this.comercial.layer = this.$parent.createLayer(this.comercial);
        }

        for (let index = 0; index < results[1].data.length; index++) {
          results[1].data[index].active = false;
          results[1].data[index].count = 0;
        }

        this.caldera.layers = results[1].data;
        if (this.hasPermision(this.caldera, 'V')) {
          this.caldera.layer = this.$parent.createLayer(this.caldera);
        }

        // this.getCountComercial('geovisor:comercial')
        // this.getCountComercial('geovisor:caldera')

        // this.getVisibility()
      });
    },
    loadNotifications: function () {
      this.$http.get('notificaciones/', {
        params: {
          id_usuario: this.user.id,
          not_paginated: true,
          ordering: '-create_date'
        }
      }).then(result => {
        this.notifications = result.data;
        if (this.notCount > 0) {
          this.showNotifications = true;
        }
      });
    },
    setDraw (result) {
      this.$parent.drawFlag = result;
    },
    setInitialComercialFilter (data) {
      this.$refs.filtercomercial.setInitialFiltros(data);
    },
    setInitialCalderaFilter (data) {
      this.$refs.filtercaldera.setInitialFiltros(data);
    }
  },
  computed: {
    isMap () {
      return this.$route.name === 'Map';
    },
    notCount: function () {
      return this.notifications.filter(e => !e.leido).length;
    },
    notCountAlert: function () {
      return this.alerts.filter(e => !e.leido).length;
    },
    isPre () {
      return (window.location.hostname === 'geovisor-pre.kernel-analytics.com' || window.location.hostname === 'geovisor-pre.nedgia.es');
    },
    user_is_api_admin () {
      try {
        return this.user.groups.map(x => {
          return x.name;
        }).includes('Admin');
      } catch (err) {
        return false;
      }
    },
    layersList () {
      return this.$parent.map.layers;
    }
  },
  mounted: function () {
    var wsPath = Vue.http.options.ws_root;
    this.socket = new ReconnectingWebSocket(wsPath);

    var th = this;
    this.socket.onmessage = function (message) {
      var data = JSON.parse(message.data);
      if (data.action === 'newAlert') {
        th.$http.get('alertas/', {
          params: {
            id_usuario: th.user.id,
            not_paginated: true,
            ordering: '-create_date'
          }
        }).then(result => {
          th.alerts = result.data;
          if (th.notCountAlert > 0) {
            th.showAlerts = true;
          }
        });
      }
    };
    this.socket.onopen = function (evt) {
      console.log('WS - Open: ' + JSON.stringify(evt));
    };
    this.socket.onclose = function (evt) {
      console.log('WS - Close: ' + JSON.stringify(evt));
    };

    this.socket.onerror = function (evt) {
      console.log('WS - Error: ' + JSON.stringify(evt));
    };

    // this.$http.get('tokens/' + Vue.cookie.get('kernel_token') + '/').then(response => {
    //   this.user = response.data.user
    //   this.userLoaded = true
    // })

    // this.$http.get('geoprovincia/filter').then(response => {
    //   this.optsfiltros.provincia = response.body.data
    //   this.optsfiltroscaldera.provincia = response.body.data
    // })

    Promise.all([
      this.$http.get('clase_establecimiento_comercial/', {params: {not_paginated: true}}),
      this.$http.get('gas_finca/', {params: {not_paginated: true}}),
      this.$http.get('status_gestion_comercial/', {params: {not_paginated: true}}),
      this.$http.get('motivo_no_potencial_comercial/', {params: {not_paginated: true}}),
      this.$http.get('categorias_gn_comercial/', {params: {not_paginated: true}}),
      this.$http.get('status_gestion_caldera/', {params: {not_paginated: true}}),
      this.$http.get('motivo_no_potencial_caldera/', {params: {not_paginated: true}}),
      this.$http.get('geoprovincia/filter'),
      this.$http.get('tokens/' + Vue.cookie.get('kernel_token') + '/'),
      this.$http.get('clase_establecimiento_caldera/', {params: {not_paginated: true}}),
      this.$http.get('categorias_gn_caldera/', {params: {not_paginated: true}}),
      this.$http.get('tipos_caldera/', {params: {not_paginated: true}})
    ]).then(results => {
      this.optsfiltros.id_clase_establecimiento_gn_comercial = /* [{id: null, index: 0, tipo: 'Todos'}].concat */(results[0].data);
      this.optsfiltros.id_gas_finca = results[1].data;
      this.optsfiltros.id_status_gestion = [{id: null, status: 'Todos'}].concat(results[2].data);
      this.optsfiltros.motivo_no_potencial = results[3].data.map(v => v.motivo);
      this.optsfiltros.id_categoria_gn_comercial = results[4].data;

      this.optsfiltroscaldera.id_gas_finca = results[1].data;
      this.optsfiltroscaldera.id_status_gestion = [{id: null, status: 'Todos'}].concat(results[5].data);
      this.optsfiltroscaldera.motivo_no_potencial = results[6].data.map(v => v.motivo_no_potencial);
      this.optsfiltroscaldera.id_clase_establecimiento_gn_caldera = [{
        id: null,
        index: 0,
        tipo: 'Todos'
      }].concat(results[9].data);
      this.optsfiltroscaldera.id_categoria_gn_caldera = results[10].data;
      this.optsfiltroscaldera.id_tipo_establecimiento_gn_caldera = results[11].data;

      this.optsfiltros.provincia = results[7].body.data;
      this.optsfiltroscaldera.provincia = results[7].body.data;

      this.user = results[8].data.user;
      this.userLoaded = true;

      this.$http.get('alertas/', {
        params: {
          id_usuario: this.user.id,
          not_paginated: true,
          ordering: '-create_date'
        }
      }).then(result => {
        this.alerts = result.data;
        if (this.notCountAlert > 0) {
          this.showAlerts = true;
        } else {
          this.loadNotifications();
        }
      });
    });
  },
  watch: {
    '$route': function () {
      this.layers = false;
      // this.$refs.layersPanel.style.width = '0px'
    },
    user () {

      // this.$parent.setLayers()
    }
  }
};
</script>

<style>
.ul-municipio {
  -moz-column-count: 4;
  -moz-column-gap: 20px;
  -webkit-column-count: 4;
  -webkit-column-gap: 20px;
  column-count: 4;
  column-gap: 20px;
  list-style: none;
}

.height {
  max-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/Navbar.vue